import { ApolloError } from '@apollo/client';

type AddUsersError =
  | { kind: 'invitations'; emails: string[] }
  | { kind: 'handled' | 'network' | 'save' };

export function getAddUsersError(error: unknown): AddUsersError {
  if (error instanceof ApolloError) {
    const invitationError = error.graphQLErrors.find(
      ({ extensions }) => extensions?.code === 'WORKSPACE_INVITATIONS_FAILED',
    );
    if (invitationError) {
      const emails = invitationError.extensions?.failedEmails;
      return {
        kind: 'invitations',
        emails: Array.isArray(emails)
          ? emails.filter((email): email is string => typeof email === 'string')
          : [],
      };
    }

    // These errors already trigger a redirect or notification in ApolloWrapper.
    if (
      error.graphQLErrors.some(
        ({ message, extensions }) =>
          message === 'Unauthorized' ||
          extensions?.code === 'VIEW_AS_MUTATION_FORBIDDEN',
      )
    ) {
      return { kind: 'handled' };
    }

    if (error.networkError) return { kind: 'network' };
  }

  return { kind: 'save' };
}
